module.exports = __webpack_public_path__ + "assets/img/smartProductBg1.a94fc7a8.png";